import {Injectable} from '@angular/core';
import {Subject, BehaviorSubject} from 'rxjs';

/**
 * Service that handle information transport between fold-detail and search for Filter purposes
 */
@Injectable()
export class UpdateSearchFiltersService {

  /**
   * fold deposit number asked to be updated in search filter
   */
  public depositNumber: Subject<string>;

  /**
   * fold send number asked to be updated in search filter
   */
  public sendNumber: Subject<string>;
  public triggerSearch: Subject<any>;

  /**
   * if the deposit number criteria is present into user search filters
   */
  public depositNumberIsPresent: BehaviorSubject<boolean>;

  /**
   * if the send number criteria is present into user search filters
   */
  public sendNumberIsPresent: BehaviorSubject<boolean>;

  /**
   * default constructor, just here to instantiate variables
   */
  constructor() {
    this.depositNumber = new Subject<string>();
    this.sendNumber = new Subject<string>();
    this.triggerSearch = new Subject<any>();
    this.depositNumberIsPresent = new BehaviorSubject<boolean>(false);
    this.sendNumberIsPresent = new BehaviorSubject<boolean>(false);
  }

}
